import { StyleSheet, Text, View } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

import { FolderFileType } from "src/core/components/pdf/shared/types";

const styles = StyleSheet.create({
  sectionTitle: {
    fontSize: 16,
    fontWeight: 500,
    color: "#00A8E3",
    marginBottom: 24,
  },
  item: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 12,
    fontSize: 12,
    color: "#0A1A53",
  },
  itemNumber: {
    width: 24,
    marginRight: 8,
    fontWeight: 600,
  },
  itemLabel: {
    flex: 1,
  },
  itemDots: {
    flex: 1,
    marginLeft: 4,
    marginRight: 4,
    fontSize: 10,
    color: "#999",
  },
  itemPageNumber: {
    flexShrink: 0,
    marginLeft: 8,
  },
});

type SommaireSectionProps = {
  folderFile: FolderFileType;
};

const SOMMAIRE_ITEM_KEYS = {
  synthesis: "pdf.sections.sommaire.synthesis",
  graph: "pdf.sections.sommaire.graph",
  missions: "pdf.sections.sommaire.missions",
  stakeholders: "pdf.sections.sommaire.stakeholders",
  lab: "pdf.sections.sommaire.lab",
  diligences: "pdf.sections.sommaire.diligences",
} as const;

type SommaireItemKey = (typeof SOMMAIRE_ITEM_KEYS)[keyof typeof SOMMAIRE_ITEM_KEYS];

type SommaireItem = {
  id: keyof typeof SOMMAIRE_ITEM_KEYS;
  labelKey: SommaireItemKey;
};

export const SommaireSection = ({ folderFile }: SommaireSectionProps) => {
  const { t } = useTranslation();

  const isEI = Boolean(folderFile.fileCustomerFolder?.customer?.isPerson);

  const items: SommaireItem[] = [
    { id: "synthesis", labelKey: SOMMAIRE_ITEM_KEYS.synthesis },
    ...(isEI ? [] : [{ id: "graph" as const, labelKey: SOMMAIRE_ITEM_KEYS.graph }]),
    { id: "missions", labelKey: SOMMAIRE_ITEM_KEYS.missions },
    { id: "stakeholders", labelKey: SOMMAIRE_ITEM_KEYS.stakeholders },
    { id: "lab", labelKey: SOMMAIRE_ITEM_KEYS.lab },
  ];
  if (folderFile?.diligences.length > 0) {
    items.push({ id: "diligences", labelKey: SOMMAIRE_ITEM_KEYS.diligences });
  }

  return (
    <View
      style={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <View style={{ width: "80%" }}>
        <Text style={styles.sectionTitle}>{t("pdf.sections.sommaire.title")}</Text>

        {items.map((item) => (
          <View key={item.id} style={styles.item}>
            <Text style={styles.itemLabel}>{t(item.labelKey)}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};
